import { useTheme } from '../../../hooks/useTheme';
import { hexToRGB } from '../../../themes/helpers';

export const SidebarDivider = () => {
  const theme = useTheme();
  return (
    <div
      css={{
        height: '1px',
        margin: '0.5rem 0',
        background: `rgba(${hexToRGB(theme.palette.background.secondary)}, 0.2)`,
      }}
    >
      &nbsp;
    </div>
  );
};
